export const goalPercentage = (goals, games) => goals > 0 ? Number.parseFloat(goals / games * 100).toFixed(1) : 0